module.exports = __webpack_public_path__ + "media/images/ibu__icon__selected-53a2da01beb1046ed93956ef51ea02b1.svg";